module.exports = __webpack_public_path__ + "img/paginationright-disabled.74d1cb0b.svg";